<template>
    <div class="d-flex justify-center">
        <v-card
            :width="mobile ? '90%' : '65%'"
            max-height="78vh"
            color="white"
            elevation="3"
            class="d-flex flex-column"
        >
            <v-data-table-server
                :headers="stock.headers"
                :items="stock.lstStock"
                :items-per-page="stock.itemsPerPage"
                no-data-text="Nenhum estoque encontrado"
                @click:row="openStock"
                class="card-scroll"
                :page="stock.page"
                :items-length="stock.totalItems"
                @update:options="updateOptions"
            >
                <template v-slot:top>
                    <div :class="['px-5', mobile ? 'pb-3' : '']">
                        <v-row align="center" dense>
                            <v-col cols="12" md="9">
                                <v-text-field
                                    v-model="stock.search"
                                    label="Pesquise aqui"
                                    variant="outlined"
                                    color="primary"
                                    density="compact"
                                    max-width="300px"
                                    rounded
                                    class="pt-6"
                                    @keyup.enter="search()"
                                >
                                    <template v-slot:append-inner>
                                        <v-btn
                                            icon
                                            size="small"
                                            variant="text"
                                            @click="search()"
                                        >
                                            <v-icon class="pt-1">mdi-magnify</v-icon>
                                        </v-btn>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="3" class="d-flex justify-end">
                                <v-btn
                                    color="primary"
                                    @click="openNewStock()"
                                    rounded
                                    variant="elevated"
                                >
                                    Adicionar
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                    <v-divider></v-divider>
                </template>
                <template #headers="{ columns }">
                    <tr class="custom-header" >
                        <th v-for="column in columns" :key="column.key" style="text-align: center; font-weight: 600;">
                            {{ column.title }}
                        </th>
                    </tr>
                </template>
            </v-data-table-server>
        </v-card>
    </div>
    <Stock/>
</template>

<script>
import Stock from '../Stock.vue';
import { useDisplay } from 'vuetify'

export default {
    setup () {
        const { mobile } = useDisplay()
        return { mobile }
    },
    data: () => ({
    }),
    components: {
        Stock
    },
    computed: {
        stock: {
            get() {
                return this.$store.state.stock
            },
        },
    },
    methods: {
        async openStock(event, row) {
            this.$router.push({
                name: 'EditStock',
                params: {
                    stockId: row.item.stockId
                }
            })
        },
        openNewStock() {
            this.$router.push({ name: 'NewStock' })
        },
        async search() {
            await this.$store.dispatch("stock/search", { limit: this.stock.itemsPerPage, reset: true })
        },
        async updateOptions(options) {
            this.$store.commit('stock/setPage', options.page)

            await this.$store.dispatch("stock/search", {
                limit: options.itemsPerPage,
                page: options.page,
                reset: true
            })
        }
    },
    async mounted() {
        await this.search()
        await this.$store.dispatch('pot/findAll')
        await this.$store.dispatch('category/findAll')
    },
    watch: {
        '$store.state.stock.shouldReload': {
            async handler(val) {
                if (val) {
                    await this.search()
                    this.$store.commit('stock/setShouldReload', false)
                }
            }
        }
    }
}
</script>

<style>
.card-scroll {
  overflow-y: auto;
  scrollbar-width: thin;
}

</style>